<div style="min-width: 350px; caret-color: transparent">
  <div>
    <h3 class="mb-0">
      <span class="font-weight-bold">Instrucciones:</span><br />
    </h3>
    <p>
      Para las sesiones en las que no se activa la opci&oacute;n de QR maestro,
      se genera un QR de asistencia para cada d&iacute;a de la sesi&oacute;n,
      mientras que para las que s&iacute; utilizan la opci&oacute;n, se genera
      un QR &uacute;nico (un solo escaneo acredita la participaci&oacute;n).
      Pide a los participantes que realicen el escaneo del QR para registrar su
      asistencia de acuerdo con lo mencionado.
    </p>
    <h2>Total de partes: {{ data.totalPartesReales }}</h2>
    <div class="text-center">
      <h2>
        C&oacute;digo QR
        <span *ngIf="data.QrMeastro"> Maestro </span>
        <span *ngIf="!data.QrMeastro">
          para el d&iacute;a: {{ selectedSession }}
        </span>
      </h2>
      <ngx-qrcode
        #QR
        [elementType]="elementType"
        [value]="urlToRedirect"
        cssClass="aclass"
        [width]="250">
      </ngx-qrcode>
      <div
        class="d-flex justify-content-center align-content-center"
        *ngIf="!data.QrMeastro">
        <div class="select-container">
          <select
            ngbTooltip="Selecciona un día"
            class="form-select"
            [(ngModel)]="selectedSession"
            (change)="updateValue()">
            <option
              *ngFor="let session of numeroSessiones; let i = index"
              [value]="i + 1">
              D&iacute;a {{ i + 1 }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-evenly align-content-center mb-2 mt-4">
    <div class="col-3 mx-1 p-1">
      <button
        type="button"
        id="copy-qr-url"
        class="btn btn-secondary-cap"
        (click)="copyUrl()"
        ngbTooltip="URL Copiada al portapapeles"
        triggers="manual"
        #tooltip="ngbTooltip">
        <span> Copiar Url </span>
      </button>
    </div>
    <div class="col-3 p-1">
      <button class="btn btn-primario" id="download-qr" (click)="saveQr()">
        <span>Descargar QR</span>
      </button>
    </div>
    <div class="col-3 mx-1 p-1">
      <button
        type="button"
        id="close-qr-modal"
        (click)="closeModal()"
        class="btn btn-secondary-cap">
        <span> Cerrar </span>
      </button>
    </div>
  </div>
</div>
